goog.provide('el8.apphome.docMgr.ImageSelector');

goog.require('el8.util.base');
goog.require('el8.util.dom');


el8.apphome.docMgr.ImageSelector = function(spec) {

    this._container = spec.container;
    this._scrollContainer = spec.scrollContainer || null;
    this._counterSelector = spec.counterSelector || null;
    this._singleSelect = (spec.singleSelect === true); // defaults to false

    this._selector = '.thumbnail-item:not([data-lock]), .preview-item:not([data-lock])';
    this._imageWrapSelector = '.image-item-wrap';
    this._selectedClass = 'el8ImageSelected';
    this._idAttr = 'data-id';

    this._selectedList = []; // Array of {elt: $elt, index: index, id: id}
    this._selectedIds = {}; // Object mapping id back to selected list 1-based index

    this._multiSelectMode = false;
    this._batchSelectMode = false;

    this._selectedImagesOnFn = spec.selectedImagesOnFn || function() {}; // fires on a new image selection
    this._selectedImagesOffFn = spec.selectedImagesOffFn || function() {}; // fires on an image deselection
    this._syncSelectImageFn = spec.syncSelectImageFn || null;

    this._bindTriggers();
};

el8.apphome.docMgr.ImageSelector.prototype._bindTriggers = function() {
    var that = this;
    this._container.on('click', this._selector, function(e) {

        if ($(e.target).hasClass('download-trigger')) { return; }

        var isCheckbox = $(e.target).is(':input[type="checkbox"]');

        if (isCheckbox || that._multiSelectMode) {
            // Clicking should toggle select/deselect image
            that._toggleImage($(this));
        } else if (that._batchSelectMode) {
            var batchRange = that._getBatchRange($(this));
            // Only do something if a batch range is returned
            if (batchRange) {
                that._selectRange(batchRange['start'], batchRange['end']);
            }
        } else {
            // Always have at least one image selected
            // Deselect all existing, and select current image
            that.clearSelection();
            that._selectImage($(this));
        }
    });
};

el8.apphome.docMgr.ImageSelector.prototype.startListen = function() {
    var that = this;
    this._multiSelectMode = false;
    this._batchSelectMode = false;
    this._listenKeys();
    return this;
};

el8.apphome.docMgr.ImageSelector.prototype.stopListen = function() {
    this._multiSelectMode = false;
    this._batchSelectMode = false;
    this._silenceKeys();
    return this;
};

el8.apphome.docMgr.ImageSelector.prototype.freeze = function() {
    this.stopListen();
    this.clearSelection();
    this._frozen = true;
};

el8.apphome.docMgr.ImageSelector.prototype.unfreeze = function() {
    this.startListen();
    this.clearSelection();
    this._frozen = false;
};

el8.apphome.docMgr.ImageSelector.prototype.clearSelection = function() {
    var eltsToClear = this._selectedList.map(function(obj) { return obj['elt']; });
    for (var i=0; i<eltsToClear.length; i++) {
        this._deselectImage(eltsToClear[i]);
    }
};

el8.apphome.docMgr.ImageSelector.prototype.removeImage = function(id) {
    this._removeFromSelectedList(id);
    delete this._selectedIds[id];

    this._selectedImagesOffFn();

    this.updateCounter();
};

el8.apphome.docMgr.ImageSelector.prototype.isAnySelected = function() {
    return Boolean(this._selectedList.length);
};

el8.apphome.docMgr.ImageSelector.prototype.isMultipleSelected = function() {
    return (this._selectedList.length > 1);
};

el8.apphome.docMgr.ImageSelector.prototype.forceSelectImage = function($elt, doSync, doScroll) {
    if (!this._isImageSelected($elt)) {
        if (!this._multiSelectMode) {
            this.clearSelection();
        }
        this._selectImage($elt, doSync);
    }
    if (doScroll && this._scrollContainer) {
        if (el8.util.dom.isAboveTop($elt, this._scrollContainer)) {
            this._scrollContainer.scrollTo($elt, {duration: 600});
        } else if (el8.util.dom.isBelowBottom($elt, this._scrollContainer)) {
            this._scrollContainer.scrollTo($elt, {duration: 600, offset: {top: -200}});
        }
    }
};

el8.apphome.docMgr.ImageSelector.prototype.selectNthImage = function(n) {
    // 0th based index
    this._selectRange(n);
};

el8.apphome.docMgr.ImageSelector.prototype.selectAllImages = function() {
    var that = this;
    $(this._selector, this._container).each(function(i, elt) {
        var $elt = $(elt);
        var id = $elt.attr(that._idAttr);
        if (!that._selectedIds[id]) {
            that._selectImage($elt);
        }
    });
};

el8.apphome.docMgr.ImageSelector.prototype._isImageSelected = function($elt) {
    return this._selectedIds[$elt.attr(this._idAttr)];
};

el8.apphome.docMgr.ImageSelector.prototype._toggleImage = function($elt) {
    if (this._isImageSelected($elt)) {
        this._deselectImage($elt);
    } else {
        this._selectImage($elt);
    }
};

el8.apphome.docMgr.ImageSelector.prototype._selectImage = function($elt, doSync) {

    if (this._frozen) { return; }

    var wasMultipleImages = this.isMultipleSelected();
    var $checkbox = $('input[type="checkbox"]', $elt);
    if ($checkbox.length) { $checkbox.prop('checked', true); }
    $(this._imageWrapSelector, $elt).addClass(this._selectedClass);

    var id = $elt.attr(this._idAttr);
    this._selectedList.push({
        elt: $elt,
        id: id
    });
    this._selectedIds[id] = true;

    if (this.isAnySelected()) {
        this._selectedImagesOnFn();
    }
    this.updateCounter();

    if (doSync !== false) {  // defaults to true
        if (this._syncSelectImageFn) { this._syncSelectImageFn(id); }
    }
};

el8.apphome.docMgr.ImageSelector.prototype._deselectImage = function($elt) {

    if (this._frozen) { return; }

    var wasMultipleImages = this.isMultipleSelected();
    var $checkbox = $('input[type="checkbox"]', $elt);
    if ($checkbox.length) { $checkbox.prop('checked', false); }
    $(this._imageWrapSelector, $elt).removeClass(this._selectedClass);

    var id = $elt.attr(this._idAttr);
    this._removeFromSelectedList(id);
    delete this._selectedIds[id];

    this._selectedImagesOffFn();

    this.updateCounter();
};

el8.apphome.docMgr.ImageSelector.prototype._selectRange = function(index1, index2) {
    index2 = index2 || index1;  // if index2 not specified, default to index1
    var that = this;
    $(this._selector, this._container).slice(index1, index2+1).each(function(i, elt) {
        var id = $(elt).attr(that._idAttr);
        if (!that._selectedIds[id]) {
            that._selectImage($(elt));
        }
    });
};

el8.apphome.docMgr.ImageSelector.prototype.updateCounter = function() {
    if (!this._counterSelector) { return; }
    var count = this._selectedList.length;
    $(this._counterSelector, this._container).text(count);
};

el8.apphome.docMgr.ImageSelector.prototype._listenKeys = function() {
    function isMultiSelect(e) {
        if (el8.util.isMac()) {
            return e.key === 'Meta';
        }
        return e.key === 'Control';
    }
    function isBatchSelect(e) {
        return e.key === 'Shift';
    }

    var that = this;
    this._keydownListener = function(e) {
        if (that._singleSelect) { return; }
        if (isMultiSelect(e)) {  // ctrl key in Win
            that._multiSelectMode = true;
        } else if (isBatchSelect(e)) { // shift key
            that._batchSelectMode = true;
        }
    };

    this._keyupListener = function(e) {
        if (that._singleSelect) { return; }
        // ctrl or cmd key
        if (isMultiSelect(e)) {  // ctrl key in Win
            that._multiSelectMode = false;
        } else if (isBatchSelect(e)) { // shift key
            that._batchSelectMode = false;
        }
    };
    this._blurListener = function(e) {
        that._multiSelectMode = false;
        that._batchSelectMode = false;
    };
    $(document).on('keydown', this._keydownListener)
        .on('keyup', this._keyupListener)
        .on('blur', this._blurListener);
};

el8.apphome.docMgr.ImageSelector.prototype._silenceKeys = function() {
    $(document).unbind('keydown', this._keydownListener)
        .unbind('keyup', this._keyupListener)
        .unbind('blur', this._blurListener);
};

/**
 * Array manipulation/selection helpers
 */
el8.apphome.docMgr.ImageSelector.prototype._getBatchRange = function($elt) {
    if (!this._selectedList.length) { return null; }

    var lastSelectedElt = this._selectedList[this._selectedList.length - 1]['elt'];
    if (this._isSameElt($elt, lastSelectedElt)) { return null; }

    var index1 = $(this._selector, this._container).index($elt);
    var index2 = $(this._selector, this._container).index(lastSelectedElt);
    return {
        start: Math.min(index1, index2),
        end: Math.max(index1, index2)
    };
};

el8.apphome.docMgr.ImageSelector.prototype._isSameElt = function(elt1, elt2) {
    return (elt1.attr(this._idAttr) === elt2.attr(this._idAttr));
};

el8.apphome.docMgr.ImageSelector.prototype._removeFromSelectedList = function(id) {
    for (var i=0; i<this._selectedList.length; i++) {
        if (this._selectedList[i]['id']*1 === id*1) {
            this._selectedList.splice(i, 1);
            return true;
        }
    }
    return false;
};
